import React, { useEffect, useState } from 'react';
// import socket from '../utils/socket'; // Socket.IO 클라이언트 불러오기
import '../css/Header.css'
import '../css/Body.css';

// 2023-02-27 아이디 비빌번호 Input
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
// 2023-03-01 Implementation
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// 2023-03-01 Implementation
import { checkSession, loginAdmin, loginUser } from '../_actions/user_action';

// 2024-12-31 SEMIQUZ
import idSaveChkBoxOn from '../components/images/idSaveChkbox-on.svg'
import idSaveChkBoxOff from '../components/images/idSaveChkbox-off.svg';

import forceLoginChkBoxOn from '../components/images/idSaveChkbox-on.svg'
import forceLoginChkBoxOff from '../components/images/idSaveChkbox-off.svg';

import setting from '../config/setting';
import { setUserAccount, setAdminAccount, getIsLogin, getIsAdmin, clearSession } from '../utils/session';

function Login() {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");

  const [EmailValid, setEmailValid] = useState(false);
  const [PasswordValid, setPasswordValid] = useState(false);
  const [NotAllow, setNotAllow] = useState(true);

  // 2024-12-31 SEMIQUZ
  const [username, setUsername] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [forceLogin, setForceLogin] = useState(false);

  useEffect(() => {
    const savedUsername = localStorage.getItem('savedUsername');
    if (savedUsername) {
      setEmail(savedUsername);
      setUsername(savedUsername);
      setRememberMe(true);
      const regex =
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
      if (regex.test(savedUsername)) {
        setEmailValid(true);
      } else {
        setEmailValid(false);
      }
    }
  }, []);

  const handleCheckboxClick = () => {
    setRememberMe(!rememberMe);
  };

  const handleForceLoginClick = () => {
    setForceLogin(!forceLogin);
  };

  const info = require('../config/info');

  const onEmailHandler = (event) => {
    setEmail(event.target.value);
    // 2024-12-31 SEMIQUZ
    setUsername(event.target.value);

    const regex =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    if (regex.test(event.target.value)) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
    }
  };

  const onPasswordHandler = (event) => {
    setPassword(event.target.value);

    const regex =
      /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
    if (regex.test(event.target.value)) {
      setPasswordValid(true);
    } else {
      setPasswordValid(false);
    }
  };
  
  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (rememberMe) {
      localStorage.setItem('savedUsername', username);
      // console.log('setItem - savedUsername: ', username);
    } else {
      localStorage.removeItem('savedUsername');
      // console.log('removeItem - savedUsername: ');
    }

    // console.log('Email', Email);
    // console.log('Password', Password);
    // console.log('isLoginAdmin', isLoginAdmin);

    // 이전 세션 잔재를 확실히 지운 뒤 새 로그인 시도를 시작한다.
    clearSession();

    // if (isLoginAdmin && setting.force_login === "N") {
    if (isLoginAdmin && !forceLogin) {
      try {
        const action = await dispatch(checkSession({ email: Email }));

        // 서버가 응답 형식을 여러 방식으로 낼 수 있어 세 경우를 모두 허용한다.
        // (직접 payload / axios data / "Y"/"N" 문자열)
        const raw =
          action.payload?.isLoggedIn ??
          action.payload?.data?.isLoggedIn;

        // 문자열 "Y" 도, boolean true 도 모두 로그인 상태로 인정
        const isLoggedIn = raw === 'Y' || raw === true || raw === 'true';

        if (isLoggedIn) {
          alert(
            '이미 다른 기기(혹은 브라우저)에서 로그인 중입니다.\n' +
            '동시 접속은 허용되지 않습니다.'
          );
          return;  // 로그인 중단
        }
      } catch (err) {
        console.error('세션 체크 오류', err);
        alert('로그인 상태를 확인할 수 없습니다. 잠시 후 다시 시도해주세요.');
        return;
      }
    }

    let body = {
      email: Email,
      password: Password
    }

    if (isLoginAdmin) {
      dispatch(loginAdmin(body)).then(response => {
        if (response.payload.loginSuccess) {
          setAdminAccount(response.payload.adminAccount);
          window.location.replace('/AdminSetting');
        } else {
          alert('등록되지 않은 [EMS Admin] 입니다.');
        }
      }).catch((err) => console.log(err));
    } else {
      dispatch(loginUser(body)).then(response => {
        if (response.payload.loginSuccess) {
          setUserAccount(response.payload.userAccount);
          window.location.replace('/Home');
        } else {
          let msgAlert = response.payload.message;
          if (msgAlert.length > 1) {
            alert(msgAlert);
          } else {
            alert('등록되지 않은 [EMS 회원] 입니다.');
          }
        }
      }).catch((err) => console.log(err));
    }
  }

  useEffect (() => {
    if (EmailValid && PasswordValid) {
      setNotAllow(false);
      return;
    }
    setNotAllow(true);
  }, [EmailValid, PasswordValid]);

  const isAdmin = getIsAdmin();
  const isLogin = getIsLogin();
  // if (isAdmin === "Y")
  //   console.log("아이디 - Admin : isLogin", isLogin);
  // else
  //   console.log("아이디 : isLogin", isLogin)

  useEffect(() => {
    if (isLogin) {
      if (isAdmin) {
        navigate('/AdminSetting')
      } else {
        navigate('/Home');
      }
      return;
    }
  }, [isLogin, isAdmin, navigate]);

  // 2023-02-27 아이디 비빌번호 Input
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  // 2023-03-01 Implementation
  const [isLoginAdmin, setIsLoginAdmin] = useState(false);
  const handleClickIsLoginAdmin = () => setIsLoginAdmin((isLoginAdmin) => !isLoginAdmin);
  const handleMouseDownIsLoginAdmin = (event) => {
    event.preventDefault();
  }

  return (
    <div className="container">
      <div className="body-wrap-login">
        <div className="login-grop-1">
          <div className="login-layout-1">
            <div className="login-header-wrap-ems">
              <h1>EMS 환경 측정 시스템</h1>
              <h2>Environment Measurement System</h2>
            </div>
            <div className="login-header-wrap">
              {
                // isLoginAdmin ? <h1>Login - Admin</h1> : <h1>Login</h1>
              }
            </div>
            <div className="login-input-layout">
              {/* Login 컴포넌트 JSX */}
              <div
                className="login-input-title"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'  // 좌측 텍스트, 우측 체크박스 배치
                }}
              >
                <span>
                  {isLoginAdmin ? "아이디 - Admin" : "아이디"}
                </span>

                {isLoginAdmin && (
                  <div
                    className="force-login"
                    onClick={handleForceLoginClick}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      margin: 0   // marginTop 제거
                    }}
                  >
                    <img
                      src={forceLogin ? forceLoginChkBoxOn : forceLoginChkBoxOff}
                      alt="강제 로그인 체크박스"
                      style={{ width: 32, height: 32, marginRight: 8 }}
                    />
                    <label style={{ margin: 0 }}>강제 로그인</label>
                  </div>
                )}
              </div>

              <FormControl sx={{ width: '100%' }} variant="outlined">
                <OutlinedInput
                  style={{ border: '2px', borderRadius: '8px', marginTop: '12px', height: '60px' }}
                  type="text"
                  // placeholder='semiquz@gmail.com'
                  placeholder='아이디를 입력해주세요'
                  // value={Email}
                  value={username}
                  onChange={onEmailHandler}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        arial-label="toggle admin login"
                        onClick={handleClickIsLoginAdmin}
                        onMouseDown={handleMouseDownIsLoginAdmin}
                        edge="end"
                      >
                        <AdminPanelSettingsIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <div className="login-error-message">
                {!EmailValid && Email.length > 0 && (
                  // <div>올바른 이메일을 입력해주세요.</div>
                  <div>올바른 아이디를 입력해주세요.</div>
                )}
              </div>

              <div className="login-input-title">비밀번호</div>
              <FormControl sx={{ width: '100%' }} variant="outlined">
                <OutlinedInput
                  style={{ border: '2px', borderRadius: '8px', marginTop: '12px', height: '60px' }}
                  id="outlined-adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  // placeholder="영문, 숫자, 특수문자 포함 8자 이상"
                  placeholder='비밀번호를 입력해주세요'
                  value={Password}
                  onChange={onPasswordHandler}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        arial-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <div className="login-error-message">
                {!PasswordValid && Password.length > 0 && (
                  // <div>영문, 숫자, 특수문자 포함 8자 이상 입력해주세요.</div>
                  <div>올바른 비밀번호를 입력해주세요.</div>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginTop: '24px' }} onClick={handleCheckboxClick}>
                <img
                  src={rememberMe ? idSaveChkBoxOn : idSaveChkBoxOff}
                  alt="아이디 저장 체크박스"
                  style={{ width: '32px', height: '32px', marginRight: '8px' }}
                />
                <label>아이디 저장</label>
              </div>
              <div>
                <button onClick={onSubmitHandler} disabled={NotAllow} className="loginButton">로그인</button>
              </div>
            </div>
          </div>
        </div>    
      </div>
    </div>
  );
}

export default Login;
